'use client'
import styled from 'styled-components'

export const ButtonLight = styled.button`
    padding: 10px;
    background-color: #0b835b;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    gap: 6px;
    transition: background-color 0.3s ease;

    ${({ active }) => active && 'background-color: #3efffc; color: #111;'}

    &:hover {
        background-color: #3efffc;
        color: #0000004f;
        //font-weight: 600;
        text-shadow: 0px 0px 1px black;
        box-shadow:
            0 0 1px #3efffc,
            0 0 2px #3efffc,
            0 0 10px #3efffc,
            0 0 4px #3efffc;
        svg {
            color: #00000088;
            text-shadow: 0px 0px 2px black;
            filter: drop-shadow(0 0 2px #000);
        }
    }

    svg {
        font-size: 16px;
    }
`

export const ButtonBorderLight = styled.button`
    ;
    padding: 0px 16px;
    background-color: transparent;
    color: ${({ customColor }) => customColor || '#a5ffa8'};
    border: none;
    border-radius: 4px;
    font-size: 22px;
    font-weight: 300;
    gap: 6px;
    border: 1px solid ${({ customColor }) => customColor || '#a5ffa8'}; /* Color del borde */
    white-space: nowrap;
    line-height: 38px;

    cursor: pointer;
    transition: background-color 0.3s ease;

    ${({ active }) => active && 'background-color: #3efffc; color: #111;'}

    ${({ disabled }) =>
        disabled &&
        `
        color: rgba(255, 255, 255, 0.1);
        background-color: #00000033;
        border-color: #0000002a; 
        pointer-events: none;
        `}

        

    &:hover {
        background-color: ${({ customColor }) => customColor || '#a5ffa8'};
        color: #0000004f;
        text-shadow: 0px 0px 1px black;
        box-shadow:
            0 0 1px ${({ customColor }) => customColor || '#a5ffa8'}},
            0 0 2px ${({ customColor }) => customColor || '#a5ffa8'}},
            0 0 10px ${({ customColor }) => customColor || '#a5ffa8'}},
            0 0 4px ${({ customColor }) => customColor || '#a5ffa8'}};

        svg {
            color: #00000088;
            text-shadow: 0px 0px 2px black;
            filter: drop-shadow(0 0 2px #000);
        }
    }

    svg {
        font-size: 16px;
    }
`
